/**
 * WordPress dependencies
 */
const { SVG, Path } = wp.primitives;

export const logo = (
  <SVG fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 152 152">
    <Path fill-rule="evenodd" clip-rule="evenodd" d="M34.2 123.5l41.9-47.3 41.7 47.4a63.22 63.22 0 01-41.7 15.8c-16.1-.1-30.8-6.1-41.9-15.9zM76 12.7c34.9 0 63.3 28.4 63.3 63.3 0 14.4-4.8 27.6-12.9 38.3L76.1 57.1l-50.6 57.1c-8-10.6-12.8-23.8-12.8-38.2 0-34.9 28.4-63.3 63.3-63.3zM76 0C34.1 0 0 34.1 0 76s34.1 76 76 76 76-34.1 76-76S117.9 0 76 0z" fill="#6138D8" />
  </SVG>
)